import PropTypes from "prop-types";

export default PropTypes.shape({
  jobId: PropTypes.string,
  jobTitle: PropTypes.string,
  recruiterName: PropTypes.string,
  recruiterCompany: PropTypes.string,
});
